import { Subscription } from "../models/subscription";
import { SubscriptionStatus } from "../models/subscription-status";
import { SubscriptionPlanUnitType } from "../models/subscription-plan-unit-type";
import { SubscriptionPlan } from "../models/subscription-plan";

export class SubscriptionHydratorService {
    public fromJSON(subJSONString: string) {
        
        let subJSON: any = {};
        if (subJSONString) {
            try {
                subJSON = JSON.parse(subJSONString);
            } catch (error) {
                console.error("Failed to parse subscription string: ", error);
                return null;
            }
        }
        return this.fromJSONObject(subJSON);
    }

    public fromJSONObject(subJSON:any) {
        let subscription = new Subscription();
        subscription.id = +subJSON.id;
        subscription.canceledAt = this.getNullableDate(subJSON, 'canceledAt');
        subscription.currentPeriodEnd = this.getNullableDate(subJSON, 'currentPeriodEnd');
        subscription.currentPeriodStart = this.getNullableDate(subJSON, 'currentPeriodStart');
        subscription.renewalDate = this.getNullableDate(subJSON, 'renewalDate');
        subscription.endedAt = this.getNullableDate(subJSON, 'endedAt');
        subscription.quantity = +subJSON.quantity;
        subscription.status = subJSON.status;
        // subscription.quantity = 1;
        // subscription.status = SubscriptionStatus.PAST_DUE;
        subscription.total = +subJSON.total;
        // subscription.total = 30;

        let plan = new SubscriptionPlan();
        plan.id = +subJSON.plan.id;
        plan.amountPerUnit = +subJSON.plan.amountPerUnit;
        plan.name = subJSON.plan.name;
        plan.unitType = subJSON.plan.unitType;
        subscription.plan = plan;
        return subscription;
    }

    public toJSON(subscription:Subscription) {
        // we can just stringify it as we don't need any transformations here
        return JSON.stringify(subscription);
    }

    private getNullableDate(obj, property) {
        if (obj[property]) {
            return new Date(obj[property]);
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/subscription-hydrator.service.ts